const FileInputObj = {
    el: null,
    output: null,
    input: null
}

export function FileInputs() {
    const fileInputsEls = document.querySelectorAll('.js-file')
    const fileInputs = Array.from(fileInputsEls)
    return fileInputs.map(createFileInput)
}

function createFileInput(el) {
    var Obj = Object.assign({}, FileInputObj)
    init.call(Obj, el)
    return Obj
}

function init(el) {
    if (!el) {
        return
    }

    this.el = el
    this.input = el.querySelector('input[type=file]')
    this.output = el.querySelector('.js-file-output')

    this.input.addEventListener('change', fileChange.bind(this))
    this.el.addEventListener('click', evt => {
        if (evt.target.dataset.fileItem) {
            removeItem.call(this, evt.target.dataset.fileItem)
        }
    })
}

function fileChange() {
    if (this.input.files) {
        let items = Array.from(this.input.files).map(
            el => `
        <button class="o-file-input__item" data-file-item="${el.name}">
            <span>${el.name}</span>
            <div class="o-hamburger is-active">
                <div><span></span></div>
            </div>
        </button>
        `
        )
        this.output.innerHTML = items.join('')
    } else {
        this.output.innerHTML = ''
    }
}

function removeItem(fileName) {
    let newFilesList = new DataTransfer()
    for (let i = 0; i < this.input.files.length; i++) {
        if (this.input.files[i].name === fileName) {
            continue
        }

        newFilesList.items.add(this.input.files[i])
    }
    this.input.files = newFilesList.files
    fileChange.call(this)
}
